import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Nav from "@/components/liea/Nav";
import Hero from "@/components/liea/Hero";
import HowItWorks from "@/components/liea/HowItWorks";
import ForVendors from "@/components/liea/ForVendors";
import ForDrivers from "@/components/liea/ForDrivers";
import Coverage from "@/components/liea/Coverage";
import FAQ from "@/components/liea/FAQ";
import Footer from "@/components/liea/Footer";

const Landing = () => {
  return (
    <div data-testid="liea-landing" className="App">
      <Nav />
      <main>
        <Hero />
        <HowItWorks />
        <ForVendors />
        <ForDrivers />
        <Coverage />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
